<template>
  <div style="color: #333">
    <div v-loading="loading" ref="treeDiv" class="tree-container">
      <el-tree :default-expand-all="true" :highlight-current="true" :accordion="true" @node-click="getInfo" ref="tree"
        class="tree" :indent="0" :data="treeData" :props="defaultProps">
        <div class="custom-tree-node tips" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
        </div>
      </el-tree>
    </div>
  </div>
</template>
<script>
import { getTree as h_getTree, getProblemTypeInfo as h_getProblemTypeInfo, getTreeUp as h_getTreeUp } from "@/api/help";
import { getTree as v_getTree, getProblemTypeInfo as v_getProblemTypeInfo, getTreeUp as v_getTreeUp } from "@/api/supplierHelp";
let getTree = null, getProblemTypeInfo = null, getTreeUp = null;
let user = window.sessionStorage.getItem("userinfo");

if (JSON.parse(user).username === "vcenter") {
  getTree = v_getTree;
  getProblemTypeInfo = v_getProblemTypeInfo;
  getTreeUp = v_getTreeUp;
}else{
  getTree = h_getTree;
  getProblemTypeInfo = h_getProblemTypeInfo;
  getTreeUp = h_getTreeUp;
}
export default {
  props: {
    types: {
      type: Boolean,
    },
    selectVal: {
      type: String,
    },
  },
  name: "tree",
  beforeRouteEnter(to, form, next) {
    next((vm) => {
      if (to.name == "faq") {
        vm.init();
      }
    });
  },
  data() {
    return {
      treeData: [
        {
          children: [],
          id: 0,
          name: "帮助中心",
          sort: 0,
          sortId: 1,
          state: 1,
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
    };
  },
  methods: {
    getInfo(val) {
      this.$emit("classify", val);
    },
    helpCenterInit() {
      this.loading = true;
      getTreeUp().then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.loading = false;
          this.treeData = this.$options.data().treeData;
          for (let i in res.data.data) {
            this.treeData[0].children.push(res.data.data[i]);
          }
          console.log(this.treeData);
        } else {
          this.loading = false;
          this.$message.error("数据获取失败");
        }
      });
    },
    init() {
      this.loading = true;
      getTree().then((res) => {
        if (res.status == 200 && res.data.code == 0) {
          this.loading = false;
          this.treeData = res.data.data;
        } else {
          return this.$message.error("数据获取失败");
        }
      });
    },
    handleNodeClick(selectedKeys) {
      if (selectedKeys[0] || selectedKeys[0] == 0) {
        getProblemTypeInfo(selectedKeys[0]).then((res) => {
          if (res.status == 200 && res.data.data) {
          }
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.tips {
  width: 150px;
  white-space: nowrap;
  /*控制单行显示*/
  overflow: hidden;
  /*超出隐藏*/
  text-overflow: ellipsis;
  /*隐藏的字符用省略号表示*/
}

.tree-container /deep/ .el-tree>.el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 16px;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 38px;
}

.tree /deep/ .el-tree>.el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree>.el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:before {
  border-left: 1px dashed #aaadb1;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  border-top: 1px dashed #aaadb1;
  height: 20px;
  top: 12px;
  width: 24px;
}

/deep/ .ant-tree-switcher-noop,
.ant-tree-switcher {
  color: black !important;
}

/deep/ .ant-tree-switcher ant-tree-switcher_close {
  color: red !important;
}

/deep/ .ant-tree.ant-tree-show-line li span.ant-tree-switcher {
  color: black !important;
}

.help {
  width: 100%;
  text-align: center;
  height: 24px;
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #303133;
  margin: 30px auto 16px;
}
</style>
